import React, { useState } from "react";

import "./Photos.css";

function Photos() {
  // Local state to track whether the modal is open
  const [isModalOpen, setModalOpen] = useState(false);
  const [imgIndx, setImgIndx] = useState(0);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const subtitles = [
    "Brent Нαmby & Wong Jack Man at set of 'Birth of the Dragon' in 2017",
    "The book 'Joy of Wushu'",
    "Brent Нαmby, Pat Barry and Shawn Liu at Worlds",
    "Training on New Year's day - Oakland",
    "Brent Нαmby & Mαtt Cataleta at Born to Fight",
    "Cung Le, Brent Нamby and Briαn Mαdigan at World Championships in China",
    "Brent Нamby and Josh Bαrtholomew from Boston San Shou",
    "G. Vann after fight",
    "Chris Reαves, Brent Нamby and Ryαn Thompson",
    "EBM founders Dαn Cαrr, Brent Нamby, Dαvid Tircuit",
    "Oakland San Shou cutting weight for fights",
    "Oakland San Shou at Pan-Am Games with Team Brazil",
    "Russ & Brent at Fairtex Muay Thai smoker on Clementina",
    "Adαm Caldwell, Brent Нamby and Brian Madigan - before match at US Nationals",
    "Brent Нamby at World Championships in Macau China with Chinese San Shou Coach",
    "Oakland San Shou victorious at US Nationals",
    "Oakland San Shou at tournament in San Jose",
    "Brent Нamby fighting at US Nationals",
    "Oakland San Shou Team",
    "Briαn Madigαn and Iranian Champ in Macau China",
    "Brent Нamby with the head coach of Russian San Shou Team",
    "Brent Нamby & Russ Middleton",
    "Oakland San Shou Team",
    "Oakland San Shou Team - Briαn Madigαn - gold medal",
    "Rodrigo at Nationals",
    "Training at EBM Kung Fu",
  ];
  function handleClick(i) {
    setImgIndx(i);
    setModalOpen(true);
  }

  // Create an array of image paths from 0.jpg to 26.jpg
  const imagePaths = [];
  for (let i = 0; i <= 25; i++) {
    imagePaths.push(`/photos/${i}.jpg`);
  }

  return (
    <div className=" gallery-container">
      <h2>EBM Kung Fu - People</h2>
      {imagePaths.map((imgSrc, index) => (
        <div key={index} className="gallery-item">
          <img
            src={imgSrc}
            onClick={() => {
              handleClick(index);
            }}
            alt={`gallery ${index}`}
          />
        </div>
      ))}

      {/* Button to open the modal */}
      {/* <button onClick={openModal} className="open-modal-btn">
        Click here to see
      </button> */}
      {/* 
        Conditionally render the modal only if isModalOpen is true.
        Alternatively, you can always render it and toggle visibility with CSS,
        but conditional rendering is a clean approach.
      */}
      {isModalOpen && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{subtitles[imgIndx]}</h3>
            <img
              src={`/photos/${imgIndx}.jpg`}
              alt={subtitles[imgIndx]}
              style={{
                display: "block", // ensures any margin auto actually centers (if the parent isn't flex)
                margin: "0 auto", // centers horizontally if the parent is wider
                width: "100%", // scale to fit the container’s width
                height: "auto", // keeps the correct aspect ratio
                maxHeight: "900px", // prevents it from exceeding 900px in height
                objectFit: "cover", // optional: if you want to crop vs contain
              }}
            />
            {/* Close button */}
            <br />
            <button onClick={closeModal} className="close-modal-btn">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Photos;
